// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vRUMnEpV_SN9nI {
  align-items: center;
  row-gap: var(--ds-space-300, 24px);
  flex-direction: column;
  height: 100%;
  display: flex;
}

.vRUMnEpV_SN9nI h2 {
  width: 50%;
  margin: var(--ds-space-0, 0);
  font: var(--ds-font-heading-medium, 600 20px/28px var(--ds-font-family-heading, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif));
  text-align: center;
}
`, ""]);
// Exports
export var container = `vRUMnEpV_SN9nI`;
export default ___CSS_LOADER_EXPORT___;
